import { useContext } from 'react';
import ToastContext from '../providers/toast';

export default function useToast() {
  const addToast = useContext(ToastContext);

  return {
    info: (message) => addToast(message, 'info'),
    warning: (message) => addToast(message, 'warning'),
    error: (message, props) => addToast(message, 'danger', props),
    success: (message) => addToast(message, 'success'),
  };
}
